export default __webpack_public_path__ + "fonts/search-skiptrace.svg";